export default function getDateStr(date = new Date()) {
  const day = date.getDate().toString().padStart(2, "0"); // Ensure two digits
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based, so add 1
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
